import React, {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {t} from 'react-switch-lang';
import BackBtn from './img/arrow-left.svg';
import './pageHeader.scss';

const PageHeader = ({
  id,
  disabled,
  allowEdit,
  allowVerify,
  onEdit,
  onVerify,
  acceptButton,
  onAccept,
  onReject,
  requestForUpdateBtn,
  onRequestForUpdate,
  acceptRequestForUpdateBtn,
  onAcceptRequestForUpdate,
  onRejectRequestForUpdate,
  closeButton,
  onCloseRisk,
  decideButton,
  onAcceptDecide,
  onRejectDecide,
  correctTab,
  url,
  deleteAllow,
  onDeleteRisk,
  requestForDelete,
  onRequestForDelete,
  acceptRejectDelete,
  onAcceptRequestForDelete,
  onRejectForDelete,
  defaultData,
}) => {
  const history = useHistory();
  let link = localStorage.getItem('previous_link');
  const [disabledAcceptBtn,setDisabledAcceptBtn] = useState(false);
  const [disabledRejectBtn,setDisabledRejectBtn] = useState(false);

  return (
    <div className="page-header d-flex  align-items-center">
      <div className="col-6 p-0">
        <Link
          to={window.location.pathname}
          onClick={() =>
            link !== null && link !== undefined
              ? (window.location.pathname = link)
              : history.go(-1)
          }
          className="return-btn d-flex align-items-center"
        >
          <img src={BackBtn} alt="icon" />
          <span>
            {url.includes('incurred-risk')
              ? t('incurred-risk.page-header-show') +
                ' ID: ' +
                parseInt(id) +
                ' - ' +
                defaultData?.title
              : url.includes('potential-risk')
              ? t('common.potentialRiskTitle') +
                ' ID: ' +
                parseInt(id) +
                ' - ' +
                defaultData?.title
              : t('common.litigationRiskTitle') +
                ' ID: ' +
                defaultData?.risk.id +
                ' - ' +
                defaultData?.risk.title}
          </span>
        </Link>
      </div>
      {(url.includes('court-risk') ? (defaultData?.risk?.active === true) : (defaultData?.active === true)) &&
      <div className="col-6 p-0 d-flex align-items-center justify-content-end">
        {allowEdit &&
        disabled &&
        id !== undefined &&
        correctTab === 'details' &&
        !window.location.pathname.includes('edit') && (
          <button className="btn primary-submit" onClick={(e) => onEdit(e)}>
            {t('buttons.changeBtn')}
          </button>
        )}
        {requestForUpdateBtn && id !== undefined && correctTab === 'details' && (
          <button
            className="btn primary-submit"
            onClick={() => onRequestForUpdate()}
          >
            {t('buttons.requestToEdit')}
          </button>
        )}
        {closeButton && id !== undefined && correctTab === 'details' && (
          <button
            className="btn primary-submit"
            onClick={(e) => onCloseRisk(e)}
          >
            {t('buttons.closeRisk')}
          </button>
        )}

        {allowVerify && id !== undefined && correctTab === 'details' && (
          <button className="btn primary-submit ml-2" onClick={(e) => onVerify(e)}>
            {t('buttons.verifyBtn')}
          </button>
        )}

        {acceptButton && id !== undefined && correctTab === 'details' && (
          <>
            <button className="btn primary-submit" onClick={(e) => onAccept(e)}>
              {t('buttons.accept')}
            </button>
            <button
              className="secondary-btn"
              type="reset"
              onClick={(e) => onReject(e)}
            >
              {t('buttons.refuse')}
            </button>
          </>
        )}

        {decideButton && id !== undefined && correctTab === 'details' && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => onAcceptDecide(e)}
            >
              {t('buttons.acceptRiskSector')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onRejectDecide(e)}
            >
              {t('buttons.rejectRiskSector')}
            </button>
          </>
        )}

        {acceptRequestForUpdateBtn &&
        id !== undefined &&
        correctTab === 'details' && (
          <>
            <button
              className="btn primary-submit"
              onClick={(e) => onAcceptRequestForUpdate(e)}
            >
              {t('buttons.acceptUpdate')}
            </button>
            <button
              className="btn primary-cancel "
              type="reset"
              onClick={(e) => onRejectRequestForUpdate(e)}
            >
              {t('buttons.refuseUpdate')}
            </button>
          </>
        )}
        {deleteAllow && id !== undefined && correctTab === 'details' && (
          <button
            className="btn primary-cancel "
            type="reset"
            onClick={(e) => onDeleteRisk(e)}
          >
            {t('buttons.deleteBtnRisk')}
          </button>
        )}

        {requestForDelete &&
        id !== undefined &&
        correctTab === 'details' &&
        !url.includes('edit') && (
          <button
            className="btn primary-cancel "
            onClick={(e) => onRequestForDelete(e)}
          >
            {t('buttons.requestForDelete')}
          </button>
        )}
        {acceptRejectDelete && id !== undefined && correctTab === 'details' && (
          <>
            <button
              className="btn primary-submit "
              onClick={(e) => {
                setDisabledAcceptBtn(true)
                onAcceptRequestForDelete(e)
              }}
            >
              {t('buttons.onAcceptRequestForDelete')}
            </button>

            <button
              className="btn primary-cancel "
              onClick={(e) => {
                setDisabledRejectBtn(true)
                onRejectForDelete(e)
              }}
            >
              {t('buttons.onRejectRequestForDelete')}
            </button>
          </>
        )}
      </div>
      }
    </div>
  );
};

export default PageHeader;
